import { removeNulls, safeParseNullDefault } from 'shouldve-been-js';

class CurrentUser {

    private _email: string;
    private _access: string[];

    public constructor(email: string, access: string[]) {

        this._email = email;
        this._access = access;
    }

    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }

    public get access(): string[] {
        return this._access;
    }

    public set access(value: string[]) {
        this._access = value;
    }

    public copy(): CurrentUser {
        return new CurrentUser(this.email, [...this.access]);
    }

    public hasAccess(accessType: string): boolean {
        return this.access.includes(accessType);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): CurrentUser | null {

        const email: string | null = safeParseNullDefault<string>(json?.email, '');
        
        if (email === null || email === '' || !Array.isArray(json?.permissions)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call
        const access: (string | null)[] = json?.permissions.map((permission: any) => safeParseNullDefault<string>(permission, ''));

        return new CurrentUser(email, removeNulls(access));
    }
}

export default CurrentUser;